/**
 * Cho'kmali filtratsiya (Ruth) — UnitModel.
 *
 * OGOHLANTIRISH KODLARI (i18n):
 *   filtration.cakeFull        critical  cho'kma qalinligi L_max ga yetdi, Q = 0
 *   filtration.pressureLimit   warning   constantRate: ΔP_max ga yetildi (params.dPmax), o'zgarmas bosim
 *   filtration.noDrivingForce  warning   ΔP = 0 yoki Q = 0 berilgan
 *   filtration.noResistance    critical  R_m = 0 va c = 0 (cheksiz sarf — ma'nosiz sozlama)
 */
import type { UnitModel } from '../../types';
import { initState, stepDynamic } from './dynamic';
import { solveSteady } from './steady';
import type {
  FiltrationInputs,
  FiltrationOutputs,
  FiltrationParams,
  FiltrationState,
} from './types';

export const filtration: UnitModel<
  FiltrationParams,
  FiltrationInputs,
  FiltrationState,
  FiltrationOutputs,
  FiltrationOutputs
> = {
  id: 'filtration',
  init: initState,
  step: stepDynamic,
  steady: solveSteady,
};

export * from './types';
export * from './ruth';
export { solveSteady } from './steady';
export { initState, stepDynamic } from './dynamic';
